import { getOpeningHoursForStoreDate, getWeekdayHours } from './appointmentBookingUtils';

const toDateKey = (date) => (
  date instanceof Date
    ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
    : String(date || '').slice(0, 10)
);

export const getSpecialOpeningPeriods = (specialOpenings, date, teamMemberId, selectedTeamMemberIds) => {
  const dateKey = toDateKey(date);
  return (specialOpenings || [])
    .filter((item) => {
      if (String(item.date || '').slice(0, 10) !== dateKey) {
        return false;
      }
      const memberId = item.teamMemberId || item.TeamMemberId;
      if (teamMemberId) {
        return String(memberId) === String(teamMemberId);
      }
      if (selectedTeamMemberIds?.length) {
        return selectedTeamMemberIds.some((id) => String(id) === String(memberId));
      }
      return true;
    })
    .map((item) => item.period || { from: item.from, to: item.to })
    .filter((period) => period?.from && period?.to);
};

export const getColumnOpeningHours = (
  storeDetails,
  column,
  specialOpenings,
  selectedTeamMemberIds,
  workingHoursByTeamMemberId,
) => {
  const weekly = storeDetails ? getOpeningHoursForStoreDate(storeDetails, column.date) : null;
  const specialPeriods = getSpecialOpeningPeriods(
    specialOpenings,
    column.date,
    column.teamMember?.id,
    selectedTeamMemberIds,
  );

  const memberIds = column.teamMember?.id ? [column.teamMember.id] : (selectedTeamMemberIds || []);
  const ownHoursOf = (id) => workingHoursByTeamMemberId?.[String(id)];
  const membersWithOwnHours = memberIds.filter((id) => ownHoursOf(id));
  const hasOwnHours = membersWithOwnHours.length > 0;

  let weeklyPeriods = weekly?.periods || [];
  if (hasOwnHours) {
    const ownPeriods = membersWithOwnHours.flatMap((id) => getWeekdayHours(ownHoursOf(id), column.date)?.periods || []);
    const someMemberFollowsStore = memberIds.some((id) => !ownHoursOf(id));
    weeklyPeriods = [...ownPeriods, ...(someMemberFollowsStore ? weeklyPeriods : [])];
  }

  const periods = [...weeklyPeriods, ...specialPeriods];
  return {
    periods,
    openingHoursEntry: periods.length > 0 ? { periods } : (hasOwnHours ? { periods: [] } : weekly),
  };
};

export const getTeamMemberWorkingPeriods = (workingHoursByTeamMemberId, teamMemberIds, days) => (
  (teamMemberIds || []).flatMap((id) => (
    (days || []).flatMap((day) => (
      getWeekdayHours(workingHoursByTeamMemberId?.[String(id)], day)?.periods || []
    ))
  ))
);
